<template>
  <v-content>
    <v-container fluid class="pa-0">
  
      <!-- Title bar / filter -->
      <v-toolbar flat dense color="blue lighten-2" dark>
        <v-toolbar-title>Ideas: Not New</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
  
      <!-- Ideas table -->
      <v-layout row wrap>
        <v-flex xs12 fill-height>
          <v-data-table
            :headers="headers"
            :items="ideas"
            :search="search"
            :custom-filter="searchFilter"
            item-key="key"
            :must-sort="true"
            :pagination.sync="pagination"
            no-data-text="..."
            no-results-text="No results, try a different search."

            :loading="isLoading">
  
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
  
            <!-- Main data row template -->
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded" :class="{'props-expanded': props.expanded}" class="expandable">
                <td>{{ props.item.title }}</td>
                <td>{{ timestampDaysAgo(props.item.datetime.seconds) }}</td>
                <td>{{ props.item.by.displayName }}</td>
                <td class="text-xs-right px-2">
                  <v-btn icon class="mx-0">
                    <v-icon v-if="props.expanded" color="grey darken-2">keyboard_arrow_up</v-icon>
                    <v-icon v-else color="grey darken-2">keyboard_arrow_down</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
  
            <!-- Expansion template -->
            <template slot="expand" slot-scope="props">
              <idea-detail :idea="props.item"></idea-detail>
            </template>
  
          </v-data-table>
        </v-flex>
      </v-layout>
  
    </v-container>
  </v-content>
  </template>
  
  <script>
  import { DateTime } from 'luxon'
  import filter from 'lodash/filter'
  
  export default {
    data: function () {
      return {
        isLoading: true,
        ideas: [],
        search: '',
        pagination: {
          sortBy: 'datetime.seconds',
          descending: true,
          rowsPerPage: 10
        },
        headers: [
          {text: 'Idea', align: 'left', sortable: false},
          {text: 'Submitted', value: 'datetime.seconds'},
          {text: 'Submitted By', value: 'by.displayName', sortable: false},
          {text: '', sortable: false}
        ]
      }
    },
  
    methods: {
      timestampDaysAgo: function (timestamp) {
        var now = DateTime.local()
        var date = DateTime.fromMillis(timestamp * 1000)
        var diff = Math.round(now.diff(date, 'days').shiftTo('days').days)
        return diff + ' days ago'
      },
      searchFilter: function (items, query) {
        return filter(items, (item) => {
          return item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
        })
      }
    },
  
    created: function () {
      this.$store.state.firestore.collection('ideas').where('status', '!=', 'new').onSnapshot({
          includeMetadataChanges: true
      }, (ideas) => {
        var rawIdeas = []
        ideas.docs.forEach((idea) => {
          var thisIdea = idea.data()
          thisIdea.key = idea.id
          rawIdeas.push(thisIdea)
        })
        this.ideas = rawIdeas
        this.isLoading = false;
      })
    }
  }
  </script>
  